import * as React from "react"
import Logo from "../icons/logo"
import LogoWhite from "../icons/logo-white"
import {
  footerStyle,
  copyright,
  links,
  blurb,
  logos,
  footerNavList,
  footerNavListItem,
  container
} from "./footer.module.css"
export function Footer() {
  return (
      <footer className={footerStyle}>
        <div className="mx-auto">
            <LogoWhite />
            </div>
        {/* <div className={copyright}>
          Copyright &copy; {new Date().getFullYear()} · All rights reserved
        </div> */}
      </footer>
  )
}
